import React from 'react';
import { Instagram } from 'lucide-react';

export const InstagramSection = () => (
  <section className="py-16 bg-[#F5F1E8]">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <Instagram className="w-12 h-12 text-[#C9A961] mx-auto mb-4" />
      <h3 className="text-3xl font-serif text-[#8B7355] mb-4">Follow Our Journey</h3>
      <p className="text-lg text-[#8B7355]/80 mb-6">
        See more vintage-style magic and real event moments on Instagram
      </p>
      <a
        href="https://instagram.com/shot2thenines"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-[#8B7355] hover:text-[#C9A961] transition-colors text-xl font-serif"
      >
        @shot2thenines
      </a>
    </div>
  </section>
);
